import { ColumnDef } from '@tanstack/react-table';
import CurrencyCell from '../../../components/tables/cellComponents/CurrencyCell';
import { DateCell } from '../../../components/tables/cellComponents/DateCell';
import { LinkCell } from '../../../components/tables/cellComponents/LinkCell';
import { Child } from '../../../services/endpoints/people/user';
import { Order } from '../../../types/orders.type';

export const childTableColumns: ColumnDef<Child>[] = [
  {
    header: 'ID',
    accessorKey: 'id'
  },
  {
    header: 'First Name',
    accessorKey: 'first_name',
    cell: ({ row }) => (
      <LinkCell
        content={row.original.first_name}
        url={`/admin/sfc-users/children/${row.original.id}`}
      />
    )
  },
  {
    header: 'Last Name',
    accessorKey: 'last_name',
    cell: ({ row }) => (
      <LinkCell
        content={row.original.last_name}
        url={`/admin/sfc-users/children/${row.original.id}`}
      />
    )
  }
];

export const ordersTableColumns: ColumnDef<Order>[] = [
  {
    header: 'ID',
    accessorKey: 'id',
    cell: ({ row }) => (
      <LinkCell
        content={row.original.id.toString()}
        url={`/admin/orders/orders/${row.original.id}`}
      />
    )
  },
  {
    header: 'Date',
    accessorKey: 'date',
    cell: ({ row }) => {
      const isIncomplete = !row.original.transaction_id;
      return (
        <span style={isIncomplete ? { color: '#B81F69' } : undefined}>
          <DateCell date={row.original.created_at ?? ''} />
        </span>
      );
    }
  },
  {
    header: 'Session',
    accessorKey: 'course_id',
    cell: ({ row }) => (
      <LinkCell
        content={row.original.course?.title ?? ''}
        url={`/admin/schedule/sessions/${row.original.course?.id ?? row.original.course_id}`}
      />
    )
  },
  {
    header: 'Total',
    accessorKey: 'total',
    cell: ({ row }) => {
      const course = row.original.course;
      const total = row.original.registrations?.reduce((acc, r) => acc + r.price, 0) ?? 0;
      const isIncomplete = !row.original.transaction_id;
      if (course?.payment_type !== 'website') {
        return <span style={isIncomplete ? { color: '#B81F69' } : undefined}>--</span>;
      }
      return (
        <CurrencyCell
          value={total}
          txtColor={isIncomplete ? '#B81F69' : undefined}
        />
      );
    }
  }
];
